export enum BidRequestStatus {
    pending = 1,
    confirmed = 2,
    rejected = 3,
    canceled = 4,
    expired = 5,
    AutoConfirmed = 6
}
